import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleTenancyOptionUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#999" cx={28} cy={28} r={28} />
        <path
          d="M22.12 15c.16 0 .3.13.3.3v2.45H32V15.3c0-.17.13-.3.3-.3h2.15c.17 0 .3.13.3.3v2.45H37c.83 0 1.5.67 1.5 1.5v16c0 .83-.67 1.5-1.5 1.5H17.5a1.5 1.5 0 01-1.5-1.5v-16c0-.83.67-1.5 1.5-1.5h2.17V15.3c0-.17.13-.3.3-.3h2.15zM16 24.75h22.5v-1.5H16v1.5z"
          fill="#FFF"
        />
        <g transform="translate(30 28)">
          <circle fill="#CCC" cx={8} cy={8} r={8} />
          <path
            stroke="#FFF"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8 4.2v3.65l3 2.18"
          />
        </g>
      </g>
    </svg>
  );
}

SvgPicCircleTenancyOptionUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleTenancyOptionUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleTenancyOptionUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
